import AccountProtection from '../components/dashboard/AccountProtection'
import AccountSettingsController from '../components/dashboard/settings/AccountSettingsController'
import AuthGateway from '../components/auth/AuthGateway'
import DashboardController from '../components/dashboard/DashboardController'
import PasswordManagement from '../components/dashboard/PasswordManagement'
import PersonalInfo from '../components/dashboard/PersonalInfo'
import RecoveryController from '../components/dashboard/recovery/RecoveryController'
import Security from '../components/dashboard/Security'

export default [
  {
    path: 'dashboard',
    element: <AuthGateway />,
    children: [
      {
        path: '',
        element: <DashboardController />
      },
      {
        path: 'personal-info',
        element: <PersonalInfo />
      },
      {
        path: 'password-management',
        element: <PasswordManagement />
      },
      {
        path: 'security-and-sign-in',
        element: <Security />
      },
      {
        path: 'security-and-sign-in/protection',
        element: <AccountProtection />
      },
      {
        path: 'recovery',
        element: <RecoveryController />
      },
      {
        path: 'account-settings',
        element: <AccountSettingsController />
      }
    ]
  }
]
